module.exports = __webpack_public_path__ + "img/Mobile_home_img3.31fdd59b.png";